import React from 'react';
import { Link } from 'react-router-dom';

const AboutUsHome = () => {
  return (
    <section className="about-us-section light-bg mx-60 border-shape-top">
      <div className="auto-container">
        <div className="row">
          <div className="col-lg-6">
            <div className="content-block">
              <div className="title-box ">
                <div className="sub-title">about us</div>
                <h2 className="sec-title">
                  Welcome to <br /> Woodland Escape 
                </h2>
              </div>
              <div className="text">
              Woodland Escape is a tranquil American-style villa located on the banks of the Wadamba River. Overlooking, the dense Khursapar jungle, this ultraluxury homestay sits within the area ruled by the famous five tigers that rule the Pench National Park.

The King of the jungle is often spotted from Woodland Escape, when it comes to quench its thirst at the Wadamba river. You can see herds of deer, the Indian Bison or gaur all through the day. 


              </div>
              <div className="text">
              Wake up at this two-acre property that features a luxurious 2 BHK 1,500 sq feet home that incorporates a spacious living room, two bedrooms, a dining area and a fully equipped kitchen that makes it a perfect family getaway destination, where you can literally taste “Maa ke hath ka Khana". The property can comfortably accommodate six guests, or two couples with children.

It is conveniently located from most safari gates of Maharashtra and Madhya Pradesh of the Pench Tiger reserve, the closest being Khursapar which is just 10 km away.

Before you head out for a safari, you can enjoy meals cooked with love by our experienced staff and care takers who can also assist you with information of the jungle around the property.

              </div>
             
             
              {/* <div className="award d-none d-md-block" data-parallax='{"x": 20}'>
                <div className="icon">
                  <img src="/images/icons/icon-1.png" alt="Award Icon" />
                </div>
                <h4>
                  Eco-Friendly <br /> Jungle 
                </h4>
              </div> */}
            </div>
          </div>
          <div className="col-lg-6">
            <div className="image img_hover_3">
              <img src="/images/resource/image-101.jpg" alt="Woodland Escape " />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUsHome;
